import React from "react";
import { ReactTyped } from "react-typed";

export default function Banner() {
  return (
    <div className="bg-gradient-to-r from-white via-[#E6F0FF] to-[#BFD7FF] w-full min-h-screen flex items-center justify-center px-4 sm:px-6 md:px-12 py-20 md:py-40">
      
      <div className="flex flex-col items-center justify-center text-center gap-4 sm:gap-6">

        {/* MAIN TITLE */}
        <div className="text-3xl sm:text-4xl md:text-6xl font-extrabold tracking-tight bg-gradient-to-r from-[#4EA8FF] to-[#00D4FF] bg-clip-text text-transparent">
          WELCOME TO PSYCHEMETRICS
        </div>

        {/* SUBTITLE */}
        <div className="text-lg sm:text-xl md:text-3xl font-semibold text-black/90">
          Test Your Mental Health
        </div>

        <div className="text-base sm:text-lg md:text-2xl text-black/70">
          An innovative way of analysing your mind
        </div>

        {/* TYPED LINE */}
        <div className="text-lg sm:text-xl md:text-3xl font-bold text-[#4EA8FF] mt-2">
          Analyse{" "}
          <span className="text-black">
            <ReactTyped
              strings={[
                "your mental health",
                "your tests",
                "your results",
              ]}
              typeSpeed={40}
              backSpeed={50}
              loop
            />
          </span>
        </div>

      </div>
    </div>
  );
}